import IAlert from '@/viewModel/IAlert'
import IAlertList from '@/viewModel/IAlertList'
import IAlertTag from '@/viewModel/IAlertTag'

export class Alerts {
  static convertTagsArrayToFlags(
    tagsArray: { title: string; value: number }[]
  ): number {
    let flags = 0
    for (let i = 0; i < tagsArray.length; i++) {
      const curTagValue = tagsArray[i]
      flags |= curTagValue.value
    }
    return flags
  }

  static async loadAlerts(
    tags: number[],
    matchAllTags: boolean,
    onlyUnread: boolean
  ): Promise<IAlertList> {
    const queryString = new URLSearchParams()
    if (tags) queryString.append('tags', tags.join(','))
    if (matchAllTags !== undefined)
      queryString.append('matchAllTags', matchAllTags.toString())
    if (onlyUnread !== undefined)
      queryString.append('onlyUnread', onlyUnread.toString())
    const result = await fetch(`/api/Alerts?${queryString.toString()}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
    if (!result.ok) {
      console.log(
        `failed to load alerts. response: ${result.status} ${result.statusText}`
      )
      return {} as IAlertList
    } else {
      return await result.json()
    }
  }

  static async loadAlertTags(): Promise<IAlertTag[]> {
    const result = await fetch(`/api/AlertTags`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
    return (await result.json()) as IAlertTag[]
  }

  static async loadAlert(id: string): Promise<IAlert> {
    const result = await fetch(`/api/Alert/${id}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
    if (!result.ok) {
      return {} as IAlert
    } else {
      return await result.json()
    }
  }

  static async markRead(id: number): Promise<boolean> {
    const result = await fetch(`/api/Alert/${id}/Read`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
    return (await result.json()) as boolean
  }
  static async markUnRead(id: number): Promise<boolean> {
    const result = await fetch(`/api/Alert/${id}/UnRead`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
    return (await result.json()) as boolean
  }
}
